export const environment = {
  projectName: 'ABG - Reporting',
  appVar: 'reporting',
  appvar: 'reporting',
  version: "10.0.5",
  assetBaseUrl: 'https://abg-reporting-api.abg-ace.ai/assets/ace',
  baseUrl: "https://abg-reporting-api.abg-ace.ai",
  scBaseUrl: "https://abg-reporting-api.abg-ace.ai/sc",
  authBaseUrl: "https://abg-reporting-api.abg-ace.ai/au",
  soeBaseUrl: "https://abg-reporting-api.abg-ace.ai/soe",
  uploadBaseUrl: "https://abg-reporting-api.abg-ace.ai/upload",
  chartBaseUrl: "https://abg-reporting-api.abg-ace.ai/chart",
  WorkflowBaseUrl: "https://abg-reporting-api.abg-ace.ai/wkf",
  ldapFlag: false,
  production: false,
  mapboxToken: 'pk.eyJ1IjoiamVhbnBhdWwxMjM0IiwiYSI6ImNtaDk0eHc1aTB6cncydnBjZXg3cTJnMDIifQ.9D1IMY9lKxDpdgxPmBkHSQ',
  endpoints: {
    appInfo: {
      getAppVersionRegistry: 'http://172.105.79.110:9090/api/version-registry/projects/ACE/registry'
    },
    getAudit: "ace-common/api/logs/all",
    menus: {
      getMenus: '/sc/api/business/getMenuListById',
      saveMenu: '/sc/api/menu/saveMenu',
    },
    caseManagement: {
      getAlerts: '/case-management/alerts',
      addAlert: '/case-management/alerts',
      searchAlert: '/case-management/alerts/search',
    },
    operator: '/core-service/api/operator/all',
    bicCodes: {
      getAllBicCodes: '/core-service/api/business-identifier/all',
    },
    configurationValues: {
      getEntityType: '/core-service/api/configuration-values/code/equal/1002',
      getConfigValueById: '/core-service/api/configuration-values/id/equal/',
      getEntityIDType:
        '/core-service/api/configuration-values/code/equal/1015',
      getEntityActivityHitStatus:
        '/core-service/api/configuration-values/code/equal/1016',
      getEntityWatchlistType:
        '/core-service/api/configuration-values/code/equal/1004',
      getWatchlistSources: '/core-service/api/sources/all',
      getModules: '/core-service/api/system-modules/all',
      getCountries: '/core-service/api/country/all',
      getAllCities: '/core-service/api/city/all',
      getCitiesByCountry: '/core-service/api/city/countryId/equal/',
      getRiskLevelValues:
        '/core-service/api/configuration-values/code/equal/1007',
      getDualUsageGoodsTypes:
        '/core-service/api/configuration-values/code/equal/1025',
      getStopWordTypes:
        '/core-service/api/configuration-values/code/equal/1026',
      getSanctionFlagValues:
        '/core-service/api/configuration-values/code/equal/1031',
      getFlagValues: '/core-service/api/configuration-values/code/equal/1032',
      getWeightageOptions:
        '/core-service/api/configuration-values/code/equal/1042',
      getLanguageCodes:
        '/ace-common/api/configuration-values/code/equal/1063',
      getRiskCategories:
        '/core-service/api/configuration-values/code/equal/1077',
      geRiskLevelConfigTypes:
        '/core-service/api/configuration-values/code/equal/1078',
      getRiskValueType:
        '/core-service/api/configuration-values/code/equal/1079',
      getRiskMeasurementApproach:
        '/core-service/api/configuration-values/code/equal/1080',
      getControlTypes:
        '/core-service/api/configuration-values/code/equal/1081',
      getControlFunctions:
        '/product-common/api/configuration-values/code/equal/1082',
      getWorkPatterns: '/core-service/api/v2/config/values/WORK_PATTERN',
      getPrimarySites: '/core-service/api/v2/config/values/PRIMARY_SITE',
      getCommuteModes: '/core-service/api/v2/config/values/COMMUTE_MODE',
      getCarFuelTypes: '/core-service/api/v2/config/values/FUEL_TYPE',
      getHomeEnergy: '/core-service/api/v2/config/values/ENERGY_TYPE',
      getEmploymentTypes: '/core-service/api/v2/config/values/EMPLOYMENT_TYPE',
      getEmployeeStatuses: '/core-service/api/v2/config/values/EMPLOYEE_STATUS',
      getTravelTypes: '/core-service/api/v2/config/values/TRAVEL_TYPE',
      getTravelClasses: '/core-service/api/v2/config/values/TRAVEL_CLASS',
      getHotelClasses: '/core-service/api/v2/config/values/HOTEL_CLASS',
      getLocalGroundTransports: '/core-service/api/v2/config/values/GROUND_TRANSPORT',
      getEmissionCalculationMethods: '/core-service/api/v2/config/values/EMISSION_CALC_METHOD',
      getDataSources: '/core-service/api/v2/config/values/DATA_SOURCE',
      getTravelStatuses: '/core-service/api/v2/config/values/STATUS',
      getTravelSegmentStatuses: '/core-service/api/v2/config/values/STATUS',
      getEquipmentStatuses: '/core-service/api/v2/config/values/STATUS',
      getVehicleTypes: '/core-service/api/v2/config/values/VEHICLE_TYPE',
      getVehicleFuelTypes: '/core-service/api/v2/config/values/FUEL_TYPE',
      getDistanceUnits: '/core-service/api/v2/config/values/DISTANCE_UNIT',
      getEnergyUnits: '/core-service/api/v2/config/values/ENERGY_UNIT',
      getVehicleStatuses: '/core-service/api/v2/config/values/STATUS'
    },
    configValue: {
      getActivityStatus: '/core-service/api/v2/config/values/ACTIVITY_STATUS'
    },
    chatbot: {
      request_openAi: '/llm-engine/llm/llm-ai',
      request_llmModel: '/llm-engine/llm',
    },
    businessUnit: {
      getAll: '/core-service/api/v2/business-unit',
      getBusinessUnitById: '/core-service/api/v2/business-unit/',
      create: '/core-service/api/v2/business-unit',
      update: '/core-service/api/v2/business-unit/update/',
    },
    operationData: {
      getByBusinessUnitId: '/core-service/api/v2/business-unit-operational-data/business-unit/',
      updateById: '/core-service/api/v2/business-unit-operational-data/update/',
      create: '/core-service/api/v2/business-unit-operational-data',
    },
    emission: {
      getAllEmissions: '/core-service/api/verdis/emissions/',
      updateElectricityEmission:
        '/core-service/api/verdis/emissions/electricity/update/',
      updateRenewableResourcesEmission:
        '/core-service/api/verdis/emissions/renewableResources/update/',
      updatePurchasedGoodsEmission:
        '/core-service/api/verdis/emissions/purchasedGoods/update/',
      updateFugitiveEmission:
        '/core-service/api/verdis/emissions/fugitive/update/',
      updateWaterEmission: '/core-service/api/verdis/emissions/water/update/',
      updateDistrictCoolingEmission:
        '/core-service/api/verdis/emissions/districtCooling/update/',
    },
    emissionFactors: {
      getAll: '/core-service/api/v2/emission-factor/getAll',
      create: '/core-service/api/v2/emission-factor/create',
      update: '/core-service/api/v2/emission-factor/update/',
      delete: '/core-service/api/v2/emission-factor/delete/'
    },
    emissionSubCategory: {
      getAll: '/core-service/api/v2/emission-sub-category/getAll',
      create: '/core-service/api/v2/emission-sub-category/create',
      update: '/core-service/api/v2/emission-sub-category/update/',
      delete: '/core-service/api/v2/emission-sub-category/delete/'
    },
    emissionCategory: {
      getAll: '/core-service/api/v2/emission-category/getAll',
      create: '/core-service/api/v2/emission-category/create',
      update: '/core-service/api/v2/emission-category/update/',
      delete: '/core-service/api/v2/emission-category/delete/'
    },
    emissionScope: {
      getAll: '/core-service/api/v2/scope/getAll'
    },

    employee: {
      getAll: '/core-service/api/v2/employees',
      create: '/core-service/api/v2/employees',
      update: '/core-service/api/v2/employees/update/',
      delete: '/core-service/api/v2/employees/delete/'
    },
    employeeTravel: {
      getAll: '/core-service/api/v2/employee-travels',
      create: '/core-service/api/v2/employee-travels'
    },
    employeeTravelSegment: {
      create: '/core-service/api/v2/employee-travel-segments'
    },
    equipment: {
      getAll: '/core-service/api/v2/equipment',
      create: '/core-service/api/v2/equipment',
      update: '/core-service/api/v2/equipment/update/',
      delete: '/core-service/api/v2/equipment/delete/'
    },
    equipmentLibrary: {
      getAll: '/core-service/api/v2/equipment-library'
    },
    vehicleLibrary: {
      getAll: '/core-service/api/v2/vehicle-library',
      create: '/core-service/api/v2/vehicle-library',
      update: '/core-service/api/v2/vehicle-library/update/',
      delete: '/core-service/api/v2/vehicle-library/delete/'
    },
    refrigerantSystem: {
      getAll: '/core-service/api/v2/refrigerant-system'
    },
    supplier: {
      profile: {
        getAll: '/core-service/api/v2/suppliers',
        create: '/core-service/api/v2/suppliers',
        getById: '/core-service/api/v2/suppliers/',
        update: '/core-service/api/v2/suppliers/',
        delete: '/core-service/api/v2/suppliers/',
        getByClientId: '/core-service/api/v2/suppliers/client/'
      },

      activity: {
        getAll: '/core-service/api/v2/supplier-activities',
        create: '/core-service/api/v2/supplier-activities',
        getById: '/core-service/api/v2/supplier-activities/',
        update: '/core-service/api/v2/supplier-activities/',
        delete: '/core-service/api/v2/supplier-activities/',
        getBySupplierId: '/core-service/api/v2/supplier-activities/supplier/',
      },

      emissionMapping: {
        getAll: '/core-service/api/v2/supplier-emission-mappings',
        create: '/core-service/api/v2/supplier-emission-mappings',
        getById: '/core-service/api/v2/supplier-emission-mappings/',
        update: '/core-service/api/v2/supplier-emission-mappings/',
        delete: '/core-service/api/v2/supplier-emission-mappings/',
        getBySupplierId:
          '/core-service/api/v2/supplier-emission-mappings/supplier/',
      },
    },

    company: {
      getCompanyByUserId: '/core-service/api/v2/company/search/user/',
      update: '/core-service/api/v2/company/update/',
      create: '/core-service/api/v2/company'
    },

    verdis: {
      configuration: {
        domain: {
          getAll: '/core-service/api/verdis/configuration/domain/getAll',
          create: '/core-service/api/verdis/configuration/domain/create',
          update: '/core-service/api/verdis/configuration/domain/update/',
          delete: '/core-service/api/verdis/configuration/domain/delete/',
        },
        status: {
          getAll: '/core-service/api/verdis/configuration/status/getAll',
          create: '/core-service/api/verdis/configuration/status/create',
          update: '/core-service/api/verdis/configuration/status/update/',
          delete: '/core-service/api/verdis/configuration/status/delete/',
        },
        severity: {
          getAll: '/core-service/api/verdis/configuration/severity/getAll',
          create: '/core-service/api/verdis/configuration/severity/create',
          update: '/core-service/api/verdis/configuration/severity/update/',
          delete: '/core-service/api/verdis/configuration/severity/delete/',
        },
        refrigerantType: {
          getAll: '/core-service/api/verdis/configuration/refrigerant/getAll',
          create: '/core-service/api/verdis/configuration/refrigerant/create',
          update: '/core-service/api/verdis/configuration/refrigerant/update/',
          delete: '/core-service/api/verdis/configuration/refrigerant/delete/',
        },
      },
    },
  },
  constants: {
    appSlogant: 'Effortless Report Creation, Powerful Insights.',
  },
  chatbotParams: {
    type: 'llm', // accepting llm or openai
    language: 'en',
    requestType: 'chat',
  },
  case_api_url: '/case-management',
  new_case_api_url: '/new-case-mgmt/casemanagement/',
  workflow_api_url: '/workflow/',
  alert_api_url: '/alert',
  configuration_api_url: '/core-service/api',
  common_url: '/case-rule-common/api',
  rule_api_url: '/rule-management/api',
  notification_api_url: '/notification-service',
  report_api_url: '/report/api',

};
